/* global __NETTGRAV_RELEASE_ID__ */

import { getEnv } from '../lib/env';
import packageJson from '../../package.json';

const FALLBACK_VERSION =
  typeof packageJson?.version === 'string' && packageJson.version.trim()
    ? packageJson.version.trim()
    : null;

export const getBuildVersion = () =>
  (typeof __NETTGRAV_RELEASE_ID__ !== 'undefined' ? __NETTGRAV_RELEASE_ID__ : null) ||
  getEnv('REACT_APP_BUILD_VERSION') ||
  getEnv('VITE_BUILD_VERSION') ||
  getEnv('REACT_APP_VERSION') ||
  getEnv('VITE_VERSION') ||
  FALLBACK_VERSION;
